import { Form, FormInstance } from "antd";
import { TQOption } from "../ManageTemplate";
import CheckboxGridField from "./CheckboxGridField";
import CheckboxesField from "./CheckboxesField";
import DateField from "./DateField";
import DropdownField from "./DropdownField";
import FileUploadField from "./FileUploadField";
import LinearScaleField from "./LinearScaleField";
import MultipleChoiceField from "./MultipleChoiceField";
import MultipleChoiceGridField from "./MultipleChoiceGridField";
import ParagraphField from "./ParagraphField";
import RatingField from "./RatingField";
import ShortAnswerField from "./ShortAnswerField";
import TimeField from "./TimeField";

type Props = {
  index: number;
  form: FormInstance<any>;
};

const name = "questions";

export default function SelectedQuestionType({ index, form }: Props) {
  const selected = Form.useWatch(
    [name, index, "question_type"],
    form
  ) as TQOption;

  switch (selected) {
    case "short_answer":
      return <ShortAnswerField index={index} />;
    case "paragraph":
      return <ParagraphField index={index} />;
    case "multiple_choice":
      return <MultipleChoiceField name={name} index={index} form={form}  />;
    case "multiple_choice_grid":
      return <MultipleChoiceGridField name={name} index={index} form={form}  />;
    case "checkboxes":
      return <CheckboxesField name={name} index={index} form={form} />;
    case "file_upload":
      return <FileUploadField index={index} name={name} form={form} />;
    case "linear_scale":
      return <LinearScaleField name={name} index={index} form={form}  />;
    case "checkbox_grid":
      return <CheckboxGridField name={name} index={index} form={form}  />;
    case "dropdown":
      return <DropdownField index={index} />;
    case "rating":
      return <RatingField name={name} index={index} form={form} />;
    case "date":
      return <DateField index={index} />;
    case "time":
      return <TimeField index={index} />;
  }

  return null;
}
